import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useGeneralSettingsQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const generalSettingsGetPriceQuery = useQuery({
        queryKey: ["general", "get_price"],
        queryFn: () =>
            axiosPrivate
                .get("general/get_price/")
                .then(r => r.data)
    });

    return {
        // Queries
        generalSettingsGetPriceQuery
    };
}
